'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _query = require('./query');

var QUERY = _interopRequireWildcard(_query);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Types = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

var HTTP = function () {
  function HTTP() {
    _classCallCheck(this, HTTP);
  }

  _createClass(HTTP, null, [{
    key: 'makeCall',
    value: function makeCall(_ref) {
      var url = _ref.url,
          data = _ref.data,
          headers = _ref.headers,
          verb = _ref.verb;
      var config = {
        credentials: 'same-origin',
        method: verb,
        headers: _lodash2.default.pickBy(headers)
      };

      if (!_lodash2.default.has(config.headers, 'Content-Type') && verb !== Types.GET) {
        Object.assign(config, {
          headers: _extends({}, config.headers, {
            'Content-Type': 'application/json'
          })
        });
      }

      var fullUrl = url;

      if (_lodash2.default.isObject(data) && !_lodash2.default.isEmpty(data)) {
        if (verb === Types.GET) {
          var serializedData = QUERY.stringify(data);

          if (serializedData) {
            fullUrl += (_lodash2.default.includes(fullUrl, '?') ? '&' : '?') + serializedData;
          }
        } else if (_lodash2.default.get(config, 'headers.Content-Type') === 'multipart/form-data') {
          config.body = _lodash2.default.reduce(data, function (formData, val, key) {
            formData.append(key, val);
            return formData;
          }, new window.FormData());
        } else if (_lodash2.default.get(config, 'headers.Content-Type') === 'application/x-www-form-urlencoded') {
          config.body = QUERY.stringify(data);
        } else {
          config.body = JSON.stringify(data);
        }
      }

      return fetch(fullUrl, config).then(function (response) {
        return response.json().catch(function () {
          return {};
        }).then(function (data) {
          return {
            data: data,
            response: response
          };
        });
      }).catch(function (error) {
        return Promise.resolve({
          data: {
            error: _lodash2.default.isString(error) ? error : 'An error occurred'
          },
          response: {
            ok: false,
            error: error
          }
        });
      }).then(function (_ref2) {
        var data = _ref2.data,
            response = _ref2.response;

        if (!response.ok) {
          return Promise.reject(data);
        }

        return Promise.resolve(data);
      });
    } // src: https://stackoverflow.com/questions/8486099/how-do-i-parse-a-url-query-parameters-in-javascript

  }, {
    key: 'getJsonFromUrl',
    value: function getJsonFromUrl(hashBased) {
      var query = void 0;

      if (hashBased) {
        var pos = window.location.href.indexOf('?');

        if (pos === -1) {
          return {};
        }

        query = window.location.href.substr(pos + 1);
      } else {
        query = window.location.search.substr(1);
      }

      var result = {};
      query.split('&').forEach(function (partParam) {
        if (_lodash2.default.isEmpty(partParam)) {
          return;
        }

        var part = partParam.split('+').join(' '); // replace every + with space, regexp-free version

        var equalsIndex = part.indexOf('=');
        var key = equalsIndex > -1 ? part.substr(0, equalsIndex) : part;
        var val = equalsIndex > -1 ? decodeURIComponent(part.substr(equalsIndex + 1)) : '';
        var from = key.indexOf('[');

        if (from === -1) {
          result[decodeURIComponent(key)] = val;
        } else {
          var to = key.indexOf(']', from);
          var index = decodeURIComponent(key.substring(from + 1, to));
          key = decodeURIComponent(key.substring(0, from));

          if (_lodash2.default.isEmpty(result[key])) {
            result[key] = [];
          }

          if (_lodash2.default.isEmpty(index)) {
            result[key].push(val);
          } else {
            result[key][index] = val;
          }
        }
      });
      return result;
    }
  }, {
    key: 'Types',
    get: function get() {
      return Types;
    }
  }, {
    key: 'GET',
    get: function get() {
      return Types.GET;
    }
  }, {
    key: 'POST',
    get: function get() {
      return Types.POST;
    }
  }, {
    key: 'PUT',
    get: function get() {
      return Types.PUT;
    }
  }, {
    key: 'DELETE',
    get: function get() {
      return Types.DELETE;
    }
  }]);

  return HTTP;
}();

exports.default = HTTP;